module.exports = __webpack_public_path__ + "img/products-4@2x.d0160f4.webp";